export const SITE = "https://abnormalworld.it";

/* Today's date (YYYY-MM-DD) in Europe/Rome, from the visitor's clock. */
export function romeToday(now = new Date()) {
    return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}

/* "past" once the last planned day is over (Europe/Rome); admin override wins. */
export function eventStatus(ev, today = romeToday()) {
    if (ev.status_override === "archived") return "past";
    if (ev.status_override === "upcoming") return "upcoming";
    return ev.end_date < today ? "past" : "upcoming";
}

export function splitEvents(events) {
    const withStatus = events.map((e) => ({ ...e, status: eventStatus(e) }));
    const upcoming = withStatus.filter((e) => e.status === "upcoming").sort((a, b) => (Number(b.featured) - Number(a.featured)) || a.start_date.localeCompare(b.start_date));
    const past = withStatus.filter((e) => e.status === "past").sort((a, b) => b.end_date.localeCompare(a.end_date));
    return { upcoming, past, featured: upcoming[0] || null };
}

export function daysUntil(iso, today = romeToday()) {
    const [y, m, d] = iso.split("-").map(Number);
    const [ty, tm, td] = today.split("-").map(Number);
    return Math.round((Date.UTC(y, m - 1, d) - Date.UTC(ty, tm - 1, td)) / 86400000);
}

const dt = (iso) => new Date(iso + "T12:00:00");

/* "11 ottobre 2026" · "24–25 ottobre 2026" · "30 set – 2 ott 2026" */
export function fmtEventDates(ev, lang = "it", opts = {}) {
    const loc = lang === "en" ? "en-GB" : "it-IT";
    const { start_date: s, end_date: e } = ev;
    const month = opts.short ? "short" : "long";
    if (!e || e === s) return dt(s).toLocaleDateString(loc, { day: "numeric", month, year: opts.year === false ? undefined : "numeric" });
    const sameMonth = s.slice(0, 7) === e.slice(0, 7);
    const end = dt(e).toLocaleDateString(loc, { day: "numeric", month, year: opts.year === false ? undefined : "numeric" });
    const start = sameMonth ? String(Number(s.slice(8, 10))) : dt(s).toLocaleDateString(loc, { day: "numeric", month: "short" });
    return `${start}–${end}`;
}

/* dd.mm label used in stamps and compact UI */
export const ddmm = (iso) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;

export function pick(ev, field, lang) {
    return (lang === "en" && ev[`${field}_en`]) || ev[field] || "";
}

export function ytId(url) {
    if (!url) return null;
    const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
}

export const eventUrl = (ev) => `${SITE}/eventi/${ev.slug}`;
